<template>
  <v-app>
    <v-container class="primary" fluid fill-height>
      <v-layout justify-center align-center>
        <v-progress-circular :size="50" color="white" indeterminate />
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "LoadingLayout",
};
</script>
